import { useEffect } from "react";
import { Navigate, useSearchParams } from "react-router-dom";
import { HELP_ARTICLE_QUERY_PARAM } from "@/constants/help";
import { useHelpPanel } from "@/context/HelpPanelContext";
import { parseHelpArticleSlug } from "@/utils/help-context-helper";

/**
 * `/support` is a deep link, not a page: it opens the Help Center panel (whose provider lives in
 * the authenticated layout, so it survives this redirect) and sends the user on to their landing
 * screen. The redirect replaces the history entry so Back doesn't bounce through here again.
 * `open` is called, never `toggle` — React StrictMode double-invokes effects in development, and
 * a toggle would open then immediately close the panel. An `?article=` value that isn't shaped
 * like a slug opens the screen view instead.
 */
export default function Support() {
  const { open } = useHelpPanel();
  const [searchParams] = useSearchParams();
  const rawSlug = searchParams.get(HELP_ARTICLE_QUERY_PARAM);
  const articleSlug = parseHelpArticleSlug(rawSlug);

  useEffect(() => {
    if (rawSlug !== null && articleSlug === null) {
      console.warn("[help] ignoring a malformed article deep link", { article: rawSlug });
    }
    open(articleSlug ?? undefined);
  }, [open, rawSlug, articleSlug]);

  return <Navigate to="/" replace />;
}
